export class Paging {
    currentPage: number = 1;
    public startIndex: number = 0;
    public endIndex: number = 10;
    public pageCount = 10;
    public totalPages = 0;
    public totalRows: number = 0;
    public firstDisplayIndex: number = 0;
    public lastDisplayIndex: number = 0;
    public nextButtonDisabled: boolean = false;
    
    public setStartEndIndex(): void {
        this.startIndex = ((this.currentPage - 1) * this.pageCount);
        this.endIndex = ((this.currentPage - 1) * this.pageCount) + this.pageCount;
    }

    public setLastDisplayIndex(): void {
        if((this.currentPage) * this.pageCount > this.totalRows) {
            this.lastDisplayIndex = this.totalRows;
        } else {
            this.lastDisplayIndex = (this.currentPage) * this.pageCount;        
        }
    }
}

export class Pagination {
    currentPage: number = 1;
    pageSize: number = 20;
    totalPages: number = 1;
    totalRows: number = 0;
    pageSizeOptions: number[] = [10, 20, 50, 100];
    updateData: () => void;

    constructor(retrieveDataCallback: () => void) {
        this.updateData = retrieveDataCallback;
    }

    OnPageSizeChange(newPageSize: number) {
        this.pageSize = newPageSize;
        this.updateData();
    }

    onPageChange(page: number)
    {
        this.currentPage = page;
        this.updateData();
    }

    onDataUpdate(totalRows: number) {
        this.totalRows = totalRows;
        this.totalPages = Math.ceil(totalRows / this.pageSize);
    }
}

export type ParsersFilter = {
    parserFilter: string;
    descriptionFilter: string;
    startTime: string;
    endTime: string;
    startDate: string;
    endDate: string;
    startDateTime: string;
    endDateTime: string;
}
